<template>
    <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_changeDate" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">결제일 변경</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <dt>
              <span class="rew19_table_tit">결제일</span>
          </dt>
          <dd>
            <ul class="rew19_transition_table">
              <li>
                <em class="with_type1">현재</em>
                <div class="txt_type">매월 {{payment_day}}일</div>
              </li>
              <li>
                <em class="with_type1">결제 일 </em>
                <div class="rew19_form_full limit">
                  <span class="rew19_form_full">
                    <select v-model="viewData.payment_day" class="rew19_select_t1 autoFocus" >
                      <option v-for="n in 20" :value="n" :key="n" :checked="n == viewData.payment_day">{{n}}</option>                      
                    </select>
                  </span>
                </div>
              </li>
            </ul>
          </dd>
        </dl>
      
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
          <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
          <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>
  </div>  
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "PaymentDateDialog",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex: 2000,

      viewData: {
      }, 
      payment_day : null
    };
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show &&
        this.$nextTick(() => {
          let _this = this;
          _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

          this.$el.focus();
        });
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },
  methods: {
    onClose(response) {
      let _this = this;
      let resData = _this.viewData

      _this.$emit("close", response, response? resData : null);
    },
    onCancel() {
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */

    /**
     * Local
     */
    initData: function(data) {
      let _this = this;

      _this.viewData = {
        ..._this.viewData,
        ...data
      };

      _this.payment_day = data.payment_day;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/popup/PaymentDateDialog.vue